import React from "react";
import { useAssetsClearModel } from "../assetsClearModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useOrgModel } from "@/views/base/organization/orgModel";




export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useAssetsClearModel();
    const { getOrgTreeSelect } = useOrgModel(() => [])
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "清理单号",
            fieldName: "code",
            span:6
        },
        // {
        //     type: SearchTypeEnum.Input,
        //     placeholder: "清理人",
        //     fieldName: "user",
        //     span:4
        // }, {
        //     type: SearchTypeEnum.TreeSelect,
        //     placeholder: "清理部门",
        //     fieldName: "department",
        //     span:4,
        //     treeData: getOrgTreeSelect(DictCodeEnmu.ORG)
        // }, {
        //     type: SearchTypeEnum.Input,
        //     placeholder: "存放地点",
        //     fieldName: "deposit",
        //     span:4
        // },  {
        //     type: SearchTypeEnum.RangePicker,
        //     fieldName: "",
        //     rangePickerFieldName: ["startTime", "endTime"],
        //     placeholder: ["清理起始日期", "清理结束日期"],
        //     format: "YYYY-MM-DD",
        //     alloc: true,
        //     span:4
        // }, 
    ]

    return (
        <YhPageHeader
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}